<template>
  <div class="refund-audit-info" v-if="transaction">
    <div class="title">
      Audit Logs
    </div>

    <div class="content">
      <div class="event">
        {{ $t('auditLogs.' + transaction.type) }}
      </div>
      <div class="event-time">
        {{ formattedTransactionDate }}
        {{ $t('global.time.utcTimeZoneDifference', { time: getUtcTimezoneDifference()}) }}
      </div>

      <div class="event">
        Payment disputed as fraudulent
      </div>
      <div class="event-time">
        {{ formattedDisputeDate }}
        {{ $t('global.time.utcTimeZoneDifference', { time: getUtcTimezoneDifference()}) }}
      </div>
    </div>
  </div>
</template>

<script>
import {DisputeResponseDto, TransactionResponseDto} from "@/api/paymentApi";
import Formatter from "@/app/utils/common/functions/formatter";
import {getUtcTimezoneDifference} from "@/app/utils/common/functions/dateUtils";

export default {
  name: "ChargebackAuditLogs",
  props: {
    transaction: {
      type: TransactionResponseDto,
      required: true,
    },
    dispute: {
      type: DisputeResponseDto,
      required: true,
    },
  },
  computed: {
    formattedTransactionDate() {
      return this.transaction
          ? this.formatDateWithTimezone(this.transaction.created_at.toString())
          : "";
    },
    formattedDisputeDate() {
      return this.dispute
          ? this.formatDateWithTimezone(this.dispute.occurred_at.toString())
          : "";
    }
  },
  methods: {
    getUtcTimezoneDifference,
    formatDateWithTimezone(date) {
      return Formatter.format({type: 'zonedDateWithTime', data: date})
    },
  },
}
</script>

<style lang="scss">
.refund-audit-info {
  & .title {
    text-align: left;
    font-size: 16px;
    font-weight: $weight-bold;
  }

  & .content {
    margin-top: 12px;
    text-align: left;

    & .event-time {
      color: $neutral_400;
      margin-top: 4px;
      margin-bottom: 16px;
      font-size: 12px;
    }
  }
}
</style>